export const GET_UNIV_CATEGORIES = "GET_UNIV_CATEGORIES";
export const RESET_UNIV_CATEGORIES = "RESET_UNIV_CATEGORIES";
export const SET_UNIV_CATEGORIES_REQUEST_STATUS = "SET_UNIV_CATEGORIES_REQUEST_STATUS";
